<section class="bg-white py-5 min-vh-75 d-flex align-items-center">
  <div class="hero-section-main">
    <div class="event-card-container">
      <div class="row m-0">
        <!-- Left: Image -->
        <div class="col-lg-5 p-0">
          <img
            src="../../../assets/images/khanna.png"
            class="event-image img-fluid"
            alt="Rep. Ro Khanna"
          />
        </div>
        <!-- Right: Content -->
        <div
          class="col-lg-7 event-content-box d-flex flex-column justify-content-center text-center"
        >
          <div class="mb-4">
            <span class="upcoming-badge">• UPCOMING LIVE EVENT</span>
          </div>
          <h2 class="event-title fw-700 mb-2">
            Upcoming Virtual Townhall with
          </h2>
          <h2 class="event-subtitle fw-700 mb-3">Rep. Ro Khanna</h2>

          <p class="event-date-time fw-600 mb-2">
            <app-icon
              name="calendar-days"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            June 8th | 7:15 PM EST
          </p>
          <p class="event-starts-in mb-3">
            <app-icon
              name="circle-alert"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon>
            Event Starts In
          </p>

          <!-- Timer -->
          <div class="timer-container d-flex justify-content-center mb-4">
            <div class="timer-box">
              <span class="timer-value">{{ days | number : '2.0-0' }}</span>
              <span class="timer-label">DAYS</span>
            </div>
            <div class="timer-box">
              <span class="timer-value">{{ hours | number : '2.0-0' }}</span>
              <span class="timer-label">HOURS</span>
            </div>
            <div class="timer-box">
              <span class="timer-value">{{ minutes | number : '2.0-0' }}</span>
              <span class="timer-label">MINUTES</span>
            </div>
            <div class="timer-box">
              <span class="timer-value">{{ seconds | number : '2.0-0' }}</span>
              <span class="timer-label">SECONDS</span>
            </div>
          </div>
          <p class="event-description mb-4">
            Join Congressman Ro Khanna (CA-17) for a virtual town hall and
            conversation about the Epstein Files, New Economic Patriotism, and
            other conversations.
          </p>
          <p class="event-description fw-600 mb-4">
            Don't miss your chance to participate in the conversation.
          </p>

          <!-- Buttons -->
          <div class="d-flex flex-column align-items-center">
            <button
              class="btn btn-black event-btn mb-3 d-flex align-items-center justify-content-start pl-4"
              [routerLink]="['/signup']"
              [queryParams]="{ returnUrl: virtualEventReturnUrl }"
            >
              <div class="btn-icon mr-3">
                <app-icon
                  name="user-plus"
                  class="cx-icon--md"
                  aria-hidden="true"
                ></app-icon>
              </div>
              <div class="text-left">
                <p class="mb-0 font-18 fw-600">New? Sign Up & RSVP</p>
                <p class="mb-0 font-12 opacity-75">
                  Fast entry—no verification required
                </p>
              </div>
            </button>
            <button
              class="btn btn-outline-black event-btn d-flex align-items-center justify-content-start pl-4"
              [routerLink]="['/login']"
              [queryParams]="{ returnUrl: virtualEventReturnUrl }"
            >
              <div class="btn-icon mr-3">
                <app-icon
                  name="log-in"
                  class="cx-icon--sm"
                  aria-hidden="true"
                ></app-icon>
              </div>
              <div class="text-left">
                <p class="mb-0 font-18 fw-600">Member? Log In & RSVP</p>
                <p class="mb-0 font-12 opacity-75">
                  Go straight to the event page
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
